function handleReset(resetForm, setCondition = "true", setLoginMessage) {
  resetForm();
  setCondition(false);
  setLoginMessage("");
}
export default handleReset;
